import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A0A] border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-slate-400">
            &copy; {currentYear} ShellX. All rights reserved.
          </div>

          <div className="flex gap-6 text-sm">
            <Link
              to="/help"
              className="text-slate-400 hover:text-white transition"
            >
              Help Center
            </Link>
            <Link
              to="/terms"
              className="text-slate-400 hover:text-white transition"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              className="text-slate-400 hover:text-white transition"
            >
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
